import { h, Component } from 'preact';
import { route } from 'preact-router';
import { BaseComponent } from '../../common/BaseComponent';
import List from 'preact-material-components/List';
import { bind } from 'decko';
import { IDocumentFolderProps, IDocumentFolderState } from './IDocumentFolder';
import { Folder } from '../../models/Folder';
import { DocType } from '../../enums/DocType';
import { DocViewer } from '../docViewer/docViewer';
import { VideoPlayer } from '../videoPlayer/videoPlayer';
import { IModalDialogState } from '../modalDialog/IModalDialog';


let style = require('./style.scss');

export class DocumentFolder extends BaseComponent<IDocumentFolderProps, IDocumentFolderState> {

    constructor(props, ctx) {
        super(props, ctx);
        this.setState({
            currentFolder: this.props.building.documentFolder,
            currentPath: this.props.currentPath
        });
    }

    @bind
    public onFolderClick(f: Folder) {
        var cp = this.state.currentPath + f.name + "|";
        route("/documents/" + cp, true);
    }

    public setPath(path) {
        if (path) {
            var pathParts = path.split("|");
            var current = this.props.building.documentFolder;
            pathParts.forEach((val) => {
                if (val)
                    current = current.folders.filter((fval) => { return fval.name == val })[0];
            })
            this.setState({ currentFolder: current, currentPath:path });
        }
        else
            this.setState({ currentFolder: this.props.building.documentFolder, currentPath: path });
    }

    public showDocToDisplay(url: string, type: DocType) {
        this.modal.showMessageBox({
            message: this.getDocToDisplay(url, type),
            maxSize: type == DocType.Pdf,
            buttons: [
                {
                    text: "Ok",
                    onClick: () => {

                        if (type == DocType.Pdf)
                            this.refs.doc.destroy()
                        else if (type == DocType.Vimeo)
                            this.refs.video.destroy();
                        this.modal.hideDialog();
                    }
                }
            ]
        });
    }

    public getDocType(url: string): DocType {

        var lurl = url.toLowerCase();
        var imgExtensions = [".bmp", ".jpg", ".jpeg", ".png"];
        var docExtensions = [".pdf"];
        if (docExtensions.some((val) => { return lurl.endsWith(val); }))
            return DocType.Pdf;
        else if (lurl.indexOf("https://vimeo") > -1 || lurl.indexOf(".mp4") > -1)
            return DocType.Vimeo;
        else if (imgExtensions.some((val) => { return lurl.endsWith(val); }))
            return DocType.Image;
        else return DocType.Unknown;
    }

    public getDocToDisplay(url: string, type?: DocType) {
        type = type || this.getDocType(url);
        switch (type) {
            case DocType.Image:
                var f = () => { };
                var p = new Promise((res, rej) => {
                    f = () => { res(); }
                    this.modal.setState(s => { s.options.maxSize = true; return s; });
                });
                this.modal.showLoader(p);
                return <div class={`${style.popupImage}`}><img src={url} onLoad={f} /></div>
            case DocType.Pdf:
                return <DocViewer ref={this.setRef("doc")} url={url} />;
            case DocType.Vimeo:
                return <VideoPlayer ref={this.setRef("video")} url={url} playing />
        }
        return null;
    }

    componentWillMount() {
        this.setPath(this.props.currentPath);
    }

    componentWillReceiveProps(p) {
        this.setPath(p.currentPath);
    }

    render() {
         return (
        <div class={style.lists}>
            <span dangerouslySetInnerHTML={{ __html: this.props.building.documentsIntroText }}></span>

            <List>
                {this.state.currentFolder.folders.length ? this.state.currentFolder.folders.map(f => (
                    <span>
                        <List.Item onClick={() => this.onFolderClick(f)}>
                            <List.ItemGraphic>folder</List.ItemGraphic>
                            {f.name}
                        </List.Item>
                        <List.Divider />
                    </span>
                )) : ""}
            </List>

            <List>
                {this.state.currentFolder.documents.length ? this.state.currentFolder.documents.map(f => {
                    const type = this.getDocType(f.url);
                    if (type === DocType.Unknown) {
                        return (
                            <span>
                                <List.LinkItem href={f.url} target="_blank">
                                    <List.ItemGraphic>insert_drive_file</List.ItemGraphic>
                                    {f.name}
                                </List.LinkItem>
                                <List.Divider />
                            </span>
                        );
                    } else {
                        return (
                            <span>
                                <List.Item onClick={() => this.showDocToDisplay(f.url, type)}>
                                    <List.ItemGraphic>insert_drive_file</List.ItemGraphic>
                                    {f.name}
                                </List.Item>
                                <List.Divider />
                            </span>
                        );
                    }
                }) : ""}
            </List>
        </div>
    );
    }
}



// WEBPACK FOOTER //
// ./components/documentFolder/documentFolder.tsx